import { Button } from "@fluentui/react-northstar";
import { FieldDescriptors } from "@shopify/react-form-state";
import { createNominalQuestion } from "@teams/client-shared";
import { Question, QuestionType } from "@teams/types";
import React, { useCallback } from "react";

import { PollyIcon } from "../../../../_shared/components/PollyIcon";
import { AuthoringFields } from "./types";

type Props = {
  fields: FieldDescriptors<Pick<AuthoringFields, "type" | "questions">>;
  addQuestion: (
    fields: FieldDescriptors<Pick<AuthoringFields, "type" | "questions">>,
    question: Question<QuestionType>
  ) => void;
};

export const AddAnotherQuestionButton: React.FC<Props> = ({ fields, addQuestion }) => {
  const buttonClickHandler = useCallback(() => {
    addQuestion(
      fields,
      createNominalQuestion({ pointValue: 1 }, undefined, undefined, fields.type.value === "quiz")
    );

    if (fields.type.value === "poll") {
      fields.type.onChange("survey");
    }
  }, [addQuestion, fields]);

  return (
    <Button
      secondary
      icon={<PollyIcon icon="add-question-icon" inheritColor />}
      content="Add another question"
      fluid
      onClick={buttonClickHandler}
    />
  );
};
